<div id="ai-chat-page__shell" #shellContainer class="ai-chat-page__shell">
  @if (chatFormReady()) {
    <pu-ai-chat-form [isFullPage]="true" />
  }
</div>
